import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { find } from 'lodash'

import { areSameValue } from '../../core/utils'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED_MUTATION } from '../graphql/mutations'
import { UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED } from '../redux/action-types'

const useUpdateDishIngredientDiscrepancyAcceptedMutation = (
  dishId,
  ingredientId,
) => {
  const dispatch = useDispatch()

  const { loadingDiscrepancyAcceptedIngredientId, error } =
    useSelector(store =>
      find(store.dishes.dishes?.data?.result, ({ id }) =>
        areSameValue(id, dishId),
      ),
    ) || {}

  const isLoading = useMemo(
    () => areSameValue(loadingDiscrepancyAcceptedIngredientId, ingredientId),
    [ingredientId, loadingDiscrepancyAcceptedIngredientId],
  )

  const mutate = useCallback(
    async (ingredientType, value) =>
      apolloService.mutate({
        mutation: UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED_MUTATION,
        variables: { dishId, ingredientId, ingredientType, value },
        dispatch,
        action: UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED,
      }),
    [dishId, dispatch, ingredientId],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateDishIngredientDiscrepancyAcceptedMutation
